// @flow

import * as React from 'react'
import styled from 'styled-components'

import webshopWidgets from '../WebshopWidgets'
import { useWidgetTreeDataCache } from './data_cache'
import { addChildrenToGridItems } from '../WebshopEditor/shared'
import type { ConnectedBrand } from '../../../types'

type WebshopGridItemsRendererProps = {
  brand: ConnectedBrand,
  editedGridItemId?: string | null,
  gridItems: Array<Object>,
  outsideProps?: Object,
}

const WebshopGridItemsRenderer = ({
  brand,
  editedGridItemId,
  gridItems,
  outsideProps,
}: WebshopGridItemsRendererProps) => {
  const {
    dataCache,
    clearDataCache,
    initializeDataCache,
    invalidateCacheKey,
    registerWidgetTreeWidgetsToDataCache,
    removeOverrides,
    setOverrides,
  } = useWidgetTreeDataCache()

  const gridItemTrees = React.useMemo(
    () => addChildrenToGridItems(gridItems),
    [gridItems]
  )
  const gridItemTreesWithComponents = React.useMemo(
    () => addComponentToGridItems(gridItemTrees),
    [gridItemTrees]
  )

  return (
    <div>
      {gridItemTreesWithComponents.map(gridItemTree => {
        const GridItemComponent = gridItemTree.component

        if (!GridItemComponent) {
          return null
        }

        return (
          <GridItemComponent
            brand={brand}
            dataCache={dataCache}
            key={gridItemTree.id}
            editedGridItemId={editedGridItemId}
            gridItem={gridItemTree}
            invalidateCacheKey={invalidateCacheKey}
            removeOverrides={removeOverrides}
            setOverrides={setOverrides}
            outsideProps={outsideProps}
          />
        )
      })}
    </div>
  )
}

export default WebshopGridItemsRenderer

const addComponentToGridItems = gridItemTrees => {
  return gridItemTrees.map(gridItemTree => {
    const GridItemTypeComponent = webshopWidgets[gridItemTree.type] || null

    const children = addComponentToGridItems([...gridItemTree.children])

    return {
      ...gridItemTree,
      children,
      component: GridItemTypeComponent ? GridItemTypeComponent.component : null,
    }
  })
}
